import { IsTimestamp } from "../utils/decorators";

export interface Updated {
  updated?: UpdatedInfo;
}

export class UpdatedInfo {
  readonly by: string;

  @IsTimestamp()
  readonly at: Date;

  constructor(init: UpdatedInfo);

  constructor(init?: UpdatedInfo) {
    this.by = init?.by!;
    this.at = init?.at!;
  }
}

export default UpdatedInfo;
